<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1"
          >添加版本</el-button
        >
        <el-button
          type="info"
          @click="deleteSignAll(theCheckObj.id)"
          plain
          v-if="userRoleList.indexOf('')>-1"
          >删除</el-button
        >
        <span class="searchInputText">文件类型</span>
        <el-select
            class="shotType"
            v-model="search.type"
            filterable
            :validate-event="false"
            allow-create
            default-first-option
            placeholder="请选择文件类型">
            <el-option
            v-for="item in fileTypeList"
            :key="item.id"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="fileName"
              label="文件名称"
              width=""
            ></el-table-column>
            <el-table-column
              prop="version"
              label="版本号"
              width=""
            ></el-table-column>
            <el-table-column
              prop="time"
              label="上传时间"
              width=""
            ></el-table-column>
            <el-table-column label="文件类型" width="">
            <template slot-scope="scope">
                <span v-if="scope.row.type == 0">智能压实显示屏</span>
                <span v-if="scope.row.type == 1">安卓APP</span>
                <span v-if="scope.row.type == 2">智能压实网关</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="info"
              label="备注"
              width=""
            ></el-table-column>

            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <span class="lookMore" @click="openModbox(scope.row)" v-if="userRoleList.indexOf('')>-1">修改</span>
                
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="文件名称" required prop="fileName">
            <el-input
              class="longType"
              v-model="modelObj.fileName"
              maxlength="20"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="版本号" required prop="version">
            <el-input
              class="longType"
              v-model="modelObj.version"
              maxlength="20"
              placeholder="请输入版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="文件类型" required prop="type"> 
              <el-select
                  class="shotType"
                  v-model="modelObj.type"
                  filterable
                  :validate-event="false"
                  allow-create
                  default-first-option
                  placeholder="请选择文件类型">
                  <el-option
                  v-for="item in fileTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="上传版本文件:" required prop="" v-show="actionName != '修改'">
            <el-upload
              class="upload-demo lookUp_top1"
              ref="upload"
              :action="baseUrl+'/construction/version/package'"
              :on-change="handlePreview"
              :headers="header"
              :on-remove="handleRemove"
              :on-success="handlerUpload"
              :file-list="fileList"
              :limit="1"
              :data="upData"
              :auto-upload="false">
              <div class="inputCon" style="width:98px;textDecoration:underline;cursor:pointer ">
                选择文件
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              class="longType"
              v-model="modelObj.info"
              maxlength="20"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <div style="clear: both"></div>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="actionNameN"
      :visible.sync="officeShow"
      :close-on-click-modal="false"
      width="400px"
      @selection-change="handleSelectionChange"
      :row-key="fieldKey"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree
          :data="treeList"
          node-key="id"
          ref="maskTree"
          default-expand-all
          accordion
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"
        ></el-tree>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getPackages,
  setPackages,
  addRole as addPost,
  deletePackages as delPut,
  // getRoleInfo
} from "../../utils/api";
import Cookies from 'js-cookie'
import { Message } from 'element-ui';
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "ids",
      fieldRowName: "name",
      arrowList: [
        {
          name: "终端版本管理",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      search: {},
      modelObj: {
        type: '0'
      },
      actionName: "",
      treeList: [],
      dataList: [],
      activeObj: "",
      theCheckObj: "",
      officeShow: false,
      checkedKeys: [],
      actionNameN: '',
      roleValue: '',
      restaurants: '',
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      userRoleList: localStorage.getItem("userRoleList"),
      baseUrl:'',
      header:'',
      upDataShow: true,
      loading:false,
      addCengVisible:false,//新增层和修改层弹窗
      upData: {
        fileName: '',
        version: '',
        info: ''
      },
      fileList: [],
      fileTypeList:[
        {
          label: '智能压实显示屏',
          value: '0'
        },
        {
          label: '安卓APP',
          value: '1'
        },
        {
          label: '智能压实网关',
          value: '2'
        }
      ]
    };
  },
  computed: {
    rules: function () {
      return {
        fileName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        version: [{ required: true, message: "必填" }],
        officeName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        roleName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        email: [{ required: true, message: "必填" }, { trigger: "blur" }],
        type: [{ required: true, message: "必填" }, { trigger: "blur" }],
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.baseUrl=this.$store.state.baseUrl
    this.header={token:Cookies.get('token'),Authorization:Cookies.get('token')}
    this.getDataList()
  },
  methods: {
    addPost,
    delPut,
    openOffice: function () {
      console.log("111");
      this.actionNameN = "部门选择";
      this.officeShow = true;
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    getDataList: function (params) {
      getPackages(params).then((res) => {
        console.log(res);
        // let _arr = res.data.content.list.concat([]);

        // let _getDepts = function(list, _depts) {
        //   for (let i = 0; i < list.length; i++) {
        //     let _m = list[i];
        //     _depts.push({
        //       id: _m.officeCode,
        //       label: _m.officeName,
        //       originalData: _m
        //     });

        //     if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
        //       _depts[_depts.length - 1].children = [];
        //       _getDepts(_m.children, _depts[_depts.length - 1].children);
        //     }
        //   }
        // };
        // let _depts = [];
        // _getDepts(_arr, _depts);
        // this.treeList = _depts;
        this.pageMsg = this.pageAssign(res.data.content);
        this.dataList = res.data.content.info.list;
      });
    },
    handleNodeClickAdd(val){
        console.log(val)
        this.modelObj.officeName = val.label
        this.modelObj.officeCode = val.id
        this.officeShow = false
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.theCheckObj = selection[0];
      if (selection.length == 0) {
        this.checkedGh = "";
      } else {
        this.checkedGh = selection[0].id;
        this.checkedName = selection[0].sectionName;
        if (selection.length > 1) {
          this.$refs.tb.clearSelection();
          this.$refs.tb.toggleRowSelection(selection.pop());
        }
      }
    },
    roleChange: function(e){
        console.log(e)
        var roleCodeList = []
        var getList = this.restaurants
        for(var i=0;i<e.length;i++){
            for(var j=0;j<getList.length;j++){
                if(e[i] == getList[j].roleName){
                    roleCodeList.push(getList[j].roleCode)
                }
            }
        }
        console.log(roleCodeList)
        this.modelObj.roleCode = roleCodeList.join(",")
        this.modelObj.roleName = e.join(",")
    },
    setRoleInfo: function(e,d){
      console.log(e,d)
      // let params = {
      //   roleCode: e.roleCode
      // }
      // getRoleInfo(params).then(res=>{
      //   console.log(res)
      // })
      this.$router.push({path:'/transfer/roleInfo',query:{roleCode:e.roleCode,roleName:e.roleName}})
    },
    handlePreview(file,fileList){
      console.log(file,fileList,'file');
      this.fileList=fileList
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlerUpload: function (res,file, fileList) {
      console.log("upload");
      console.log(file);
      console.log(fileList);
      if(res.code==1000){
        Message.warning(res.message)
      }else{
        this.fileList=[]
        this.pageMsg.pageNo=1
        this.addModBoxVisible=false
        this.getDataList()
      }
    },
    submitUpload(){
      this.upData.fileName=this.modelObj.fileName
      this.upData.version=this.modelObj.version
      this.upData.info=this.modelObj.info
      this.upData.type=this.modelObj.type
      console.log(this.upData)
      console.log(this.fileList)
      if(this.actionName != '修改'){
        if(this.fileList.length == 0){
          this.$message({
              message: "请选择文件!",
              type: "error"
            });
        }else if(!this.upData.fileName){
          this.$message({
              message: "请填写文件名称!",
              type: "error"
            });
        }else if(!this.upData.version){
          this.$message({
              message: "请填写版本号!",
              type: "error"
            });
        }else{
          this.$refs.upload.submit();
          
        }
        
      }else{
        let params = {
          fileName: this.modelObj.fileName,
          version: this.modelObj.version,
          info: this.modelObj.info,
          id: this.modelObj.id,
          type: this.modelObj.type,
        }
        setPackages(params).then((res)=>{
          if(res.data.code==200){
            this.$message({
              message: "修改成功!",
              type: "success"
            });
            this.addModBoxVisible=false
            this.getDataList()
          }
        })
      }
    }
    
  },
  components: {
    ElPageCover,
  },
};
</script>

<style lang="scss">
// .addAndEdit {
//   .el-input {
//     width: 180px !important;
//     height: 36px !important;
//     margin-left: 23px;
//     margin-right: 23px;
//     font-size: 14px !important;
//     .el-input__inner {
//       width: 180px !important;
//       height: 36px !important;
//       border-radius: 1px !important;
//     }
//   }
// }
</style>
<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>